function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.7293 1.93958C11.0106 1.65828 11.3922 1.50024 11.79 1.50024H24.21C24.6078 1.50024 24.9894 1.65828 25.2707 1.93958L34.0607 10.7296C34.342 11.0109 34.5 11.3924 34.5 11.7902V24.2102C34.5 24.6081 34.342 24.9896 34.0607 25.2709L25.2707 34.0609C24.9894 34.3422 24.6078 34.5002 24.21 34.5002H11.79C11.3922 34.5002 11.0106 34.3422 10.7293 34.0609L1.93934 25.2709C1.65804 24.9896 1.5 24.6081 1.5 24.2102V11.7902C1.5 11.3924 1.65804 11.0109 1.93934 10.7296L10.7293 1.93958ZM12.4113 4.50024L4.5 12.4116V23.5889L12.4113 31.5002H23.5887L31.5 23.5889V12.4116L23.5887 4.50024H12.4113ZM16.5 24.0002C16.5 23.1718 17.1716 22.5002 18 22.5002H18.015C18.8434 22.5002 19.515 23.1718 19.515 24.0002C19.515 24.8287 18.8434 25.5002 18.015 25.5002H18C17.1716 25.5002 16.5 24.8287 16.5 24.0002ZM19.5 12.0002C19.5 11.1718 18.8284 10.5002 18 10.5002C17.1716 10.5002 16.5 11.1718 16.5 12.0002V18.0002C16.5 18.8287 17.1716 19.5002 18 19.5002C18.8284 19.5002 19.5 18.8287 19.5 18.0002V12.0002Z",
  fill: "#FF8300"
});

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.4fb35744.svg";
export { ForwardRef as ReactComponent };